import { Button } from 'antd';
import styled from 'styled-components';

export const ButtonsGroup = styled(Button.Group)`
  display: flex !important;

  > button {
    flex: 1;
  }
`;